import React, { Component } from 'react';

import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from '@react-google-maps/api';

import Geocode from 'react-geocode';
import Select from 'react-select';

import { APIHandler, BackButton, PremiumHotel, FreeHotel, StorageHandler } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import { storageKeys } from 'settings';

import 'simplebar/src/simplebar.css';

import MarkerFree from 'assets/images/ab-mapGrey.png';
import ClusterFree from 'assets/images/ab-mapClusterGrey.png';
import MarkerPremium from 'assets/images/ab-map.png';
import ClusterPremium from 'assets/images/ab-mapCluster.png';

import logo from 'assets/images/logo/logo_white.png';

const googleMapsApiKey = 'AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc';

let containerStyle = {
  width: '100%',
  height: 'calc(100vh - 10rem)',
};

const params = new URLSearchParams(window.location.search);
if (params.get('header')) {
  containerStyle = {
    width: '100%',
    height: '100vh',
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

export default class DirectoryNewView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 89.20250970740169,
      lat2: -85.0994183311535,
      lon1: 149.77128538528441,
      lon2: -143.17696538528443,
      query: '',
      location: '',
      country: '',
      email: 'Guest',
      continentOptions: [],
      selectedContinent: null,
      countryOptions: null,
      zoom: 1,
      header: false,
      center: {
        lat: 46.073231,
        lng: 3.29716,
      },
      color: '405866',
      font: 'Source Sans Pro',
      userInfo: '',
      mobile: false,
    };

    this.handleContinent = this.handleContinent.bind(this);
    this.handleCountry = this.handleCountry.bind(this);
    this.zoomMap = this.zoomMap.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.flyToMarker = this.flyToMarker.bind(this);
    this.premiumInfo = this.premiumInfo.bind(this);
    this.freeInfo = this.freeInfo.bind(this);
  }

  componentDidMount() {
    // Set user object in state
    this.getUser();

    Geocode.setApiKey('AIzaSyDz4fLnhaicjslT9ePw749qtgB5mWNvDQE');

    this.getStandsAndFloor();

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    let header = false;
    if (params.get('header')) {
      header = true;
    }

    if (width < 800) {
      mobile = true;
      this.getHotelsList();
    }

    this.setState({
      mobile,
      header,
    });
  }

  getUser() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj) {
        ({ email } = userObj);
      }
      this.setState({ email });
    });
  }

  getStandsAndFloor() {
    APIHandler.getExhibitionStands(715).then((res) => {
      if (res) {
        const continents = res.map(stand => stand.title).sort();
        const continentOptions = [];
  
        continents.forEach((item, index) => {
          const objects = { value: item, label: item };
          continentOptions[index] = objects;
        });
  
        this.setState({
          stands: res,
          continentOptions,
        });
      }
    });
  }

  getHotelsList() {
    setTimeout(() => {
      const {
        lat1, lat2, lon1, lon2, query, location, country, email,
      } = this.state;
      APIHandler.getFreeHotelsList(lat1, lat2, lon1, lon2, query, country).then((results) => {
        this.setState({ freeHotelsList: results });
      });
      APIHandler.getPremiumHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        location,
        country,
        email,
      ).then((results) => {
        this.setState({ premiumHotelsList: results.items });
      });
    }, 200);
  }

  handleInputChange() {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList(),
    );
  }

  loadProperties(bounds, zoom) {
    if (bounds && bounds.getNorthEast() && bounds.getNorthEast().lat()) {
      this.setState(
        {
          lat1: bounds.getNorthEast().lat(),
          lat2: bounds.getSouthWest().lat(),
          lon1: bounds.getNorthEast().lng(),
          lon2: bounds.getSouthWest().lng(),
          zoom,
        },
        this.getHotelsList(),
      );
    }
  }

  geoCode(selected) {
    Geocode.fromAddress(selected).then(
      (response) => {
        const ne = response.results[0].geometry.bounds.northeast;
        const sw = response.results[0].geometry.bounds.southwest;

        const bounds = new google.maps.LatLngBounds();
        bounds.extend(ne);
        bounds.extend(sw);
        if (this.map) {
          this.map.fitBounds(bounds);
        }
      },
      (error) => {
        console.error(error);
      },
    );
  }

  zoomMap(selectedContinent = null, selectedCountry = null) {
    let selected = '';
    if (selectedContinent !== null || selectedCountry !== null) {
      if (selectedCountry !== null) {
        selected = selectedCountry.value;
      } else if (selectedContinent !== null) {
        switch (selectedContinent.value) {
          case 'Asia Pacific':
            selected = 'China';
            break;
          case 'Central and South America':
            selected = 'South America';
            break;
          case 'Eastern Europe and Russia':
            selected = 'Eastern Europe';
            break;
          case 'North America':
            selected = 'Mexico';
            break;
          default:
            selected = selectedContinent.value;
        }
      }
      this.geoCode(selected);
    } else {
      this.setState({
        zoom: 1,
        lat1: 89.20250970740169,
        lat2: -85.0994183311535,
        lon1: 149.77128538528441,
        lon2: -143.17696538528443,
      });
    }
  }

  handleContinent(selectedContinent) {
    this.countryRef.select.clearValue();
    const { stands } = this.state;

    // Reset map to initial
    if (selectedContinent === '' || selectedContinent === null) {
      this.setState(
        { selectedContinent: null, location: '' },
        this.zoomMap(),
      );
      return;
    }

    // Zoom to continent
    if (selectedContinent !== null) {
      const countryOptions = [];
      const location = selectedContinent.value;
      const tiles = stands
        .filter(stand => stand.title === location)
        .map(stand => stand.tiles);
      const countriesDoubles = tiles[0].map(tile => tile.country).sort();
      const countries = [...new Set(countriesDoubles)];
      countries.forEach((item, index) => {
        const objects = { value: item, label: item };
        countryOptions[index] = objects;
      });

      this.setState(
        {
          countryOptions,
          selectedContinent,
          location,
          country: '',
        },
        this.zoomMap(selectedContinent),
      );
    }
  }

  handleCountry(selectedCountry) {
    const { selectedContinent } = this.state;
    if (!selectedContinent) {
      return;
    }

    if (selectedCountry === null) {
      this.setState(
        {
          country: '',
        },
        this.zoomMap(selectedContinent),
      );
      return;
    }

    const country = selectedCountry.value;
    this.setState(
      { country },
      this.zoomMap(selectedContinent, selectedCountry),
    );
  }

  flyToMarker(lat, lon) {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  }

  premiumInfo(userInfoID) {
    const { email } = this.state;
    document.getElementById('iframe').classList.remove('hide');
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=678&email=${email}`,
    });
  }

  freeInfo(userInfoID) {
    if (params.get('header') === 'false') {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=678&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        '*',
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=678&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        '*',
      );
    } else if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=678&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        '*',
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=678&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        '*',
      );
    } else {
      document.getElementById('iframe').classList.remove('hide');
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=678&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
      });
    }
  }

  closeIframe() {
    document.getElementById('iframe').classList.add('hide');
    this.setState({
      userInfo: '',
    });
  }

  render() {
    const {
      continentOptions,
      countryOptions,
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      header,
    } = this.state;

    return (
      <div className="directoryContainerNew">
        {!header && (
          <div className="header">
            <BackButton useHistory={false} text="Back" />
            <div className="search">
              <FontAwesomeIcon
                icon={['fas', 'search']}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder="Search for a hotel..."
                type="text"
                ref={input => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={`/${logo}`} className="logo" alt="logo" />
          </div>
        )}
        <div className="directoryViewNew">
          <div className="leftSide">
            <div className="results">
              Amount of results:{' '}
              {freeHotelsList && premiumHotelsList && (freeHotelsList.length + premiumHotelsList.length)}
            </div>
            <SimpleBarReact className="listContainer">
              <div className="filterTitle">Filter Spotlights per Region:</div>
              <div className="filters">
                <Select
                  className="continents"
                  options={continentOptions}
                  isClearable
                  onChange={this.handleContinent}
                  placeholder="Select a region..."
                />
                <Select
                  className="countries"
                  options={countryOptions}
                  isClearable
                  onChange={this.handleCountry}
                  isDisabled={!countryOptions}
                  placeholder="Select a country..."
                  ref={(ref) => {
                    this.countryRef = ref;
                  }}
                />
              </div>
              <div className="premiumList">
                {premiumHotelsList && premiumHotelsList.length > 0 &&
                  premiumHotelsList.map(hotel => (
                    <PremiumHotel
                      key={hotel.id}
                      id={hotel.id}
                      bgImage={hotel.headerImages[0]}
                      propertyName={hotel.propertyName}
                      other={hotel}
                      flyToMarker={() => {
                        this.flyToMarker(
                          hotel.coords.latitude,
                          hotel.coords.longitude,
                        );
                      }}
                      hotelInfo={() => {
                        this.premiumInfo(hotel.userInfoID);
                      }}
                    />
                  ))}
              </div>
              {header && (
                <style>
                  {
                    '\
              .directoryContainer { height: 100vh; } .listContainer { height: calc(100vh - 8rem) !important; }'
                  }
                </style>
              )}
              <div className="freeList">
                {freeHotelsList.length > 0 &&
                  freeHotelsList.map(hotel => (
                    <FreeHotel
                      key={hotel.company_listing_id}
                      id={hotel.company_listing_id}
                      bgImage={hotel.img_path}
                      flyToMarker={() => {
                        this.flyToMarker(hotel.latitude, hotel.longitude);
                      }}
                      hotelInfo={() => {
                        this.freeInfo(hotel.listing_id);
                      }}
                      hotelName={hotel.company}
                      location={hotel.city}
                      phoneNumber={hotel.phone}
                      address={hotel.addr1}
                      category={hotel.category}
                      other={hotel}
                    />
                  ))}
              </div>
            </SimpleBarReact>
          </div>
          <div className="rightSide">
            {!mobile && (
              <LoadScript googleMapsApiKey={googleMapsApiKey}>
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom(),
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={2}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {clusterer => (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map(freeHotel => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude,
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      )}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {clusterer => (
                        premiumHotelsList && premiumHotelsList.length > 0 &&
                        premiumHotelsList.map(premiumHotel => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude,
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      )}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            )}
          </div>

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            />
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={['fas', 'chevron-left']} /> Back
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                  title="profile"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
